module.exports = __webpack_public_path__ + "7f764f1c25f4355a4dd410f362a40ad5.MP3";